export default __webpack_public_path__ + "static/pablo-6d07dab21704bb7fba61686132c70c51.jpeg";